module.exports = __webpack_public_path__ + "img/auto-telaio.1cc3faef.svg";